import React, { useState } from "react";
import Layout from "../../Common/Layout";
import DeleteMasterClient from "./DeleteMasterClient";
import DeleteCrd from "./DeleteCrd";
import DeleteCdd from "./DeleteCdd";
import DeleteGateentries from "./DeleteGateentries";
import DeleteKataslip from "./DeleteKataslip";
import DeleteDeliveryorder from "./DeleteDeliveryorder";
// import DeleteLoan from "./DeleteLoan";

const DeleteData = () => {



  
  const [deleteType, setDeleteType] = useState("");


                               
  return (
    <>
      <Layout>
        <div
          className="container d-flex justify-content-center align-items-center"
          style={{ minHeight: "10vh", width: "30rem" }}
        >
          <select
            className="form-select"
            value={deleteType}
            onChange={(e) => setDeleteType(e.target.value)}
          >
            <option value="">-- Select Data To Delete --</option>
            <option value="master-client">Master Client</option>
            <option value="crd">Crd</option>
            <option value="cdd">Cdd</option>
            <option value="gateentries">Gate Entries</option>
            <option value="kataslip">KataSlip</option>
            <option value="deliveryorder">Delivery Order</option>

            {/* <option value="loan">Loan</option> */}
          </select>
        </div>

        {/* Render Selected Component */}

        {deleteType === "master-client" && <DeleteMasterClient />}
        {deleteType === "crd" && <DeleteCrd />}
        {deleteType === "cdd" && <DeleteCdd />}
        {deleteType === "gateentries" && <DeleteGateentries />}
        {deleteType === "kataslip" && <DeleteKataslip />}
        {deleteType === "deliveryorder" && <DeleteDeliveryorder />}

        {/* {deleteType === "loan" && <DeleteLoan />} */}
      </Layout>
    </>
  );
};

export default DeleteData;
